export * from './loyalty-tiers-widget.styled.default';
